// extracted by mini-css-extract-plugin
export default {"block":"pre_order_block__PaDiL","button":"pre_order_button__sqDbl","button_link":"pre_order_button_link__Ytsp1"};